import { Link } from 'react-router-dom';
import { ADMIN_TABS } from './AdminTabs';

/**
 * /admin landing — a minimal welcome card with links into each area. Acts as
 * a directory so a fresh admin can see every area at a glance.
 */

const TAB_DESCRIPTIONS: Record<string, string> = {
  companies: 'Create, edit, and archive client companies',
  tickets: 'View and manage support tickets',
  users: 'Manage admin, support, and client accounts',
  agreements: 'Support agreements and included increments',
  knowledgebase: 'Help articles and tagged documentation',
  workflows: 'Visual automations (Node-RED) — connect triggers to actions',
  settings: 'Third-party integrations and configuration',
  reports: 'Usage summaries, billing breakdowns, exports',
  impersonation: 'View the portal as a client (audited)',
};

export default function AdminHomePage() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-12">
      <header className="mb-8">
        <h2 className="text-2xl font-semibold">Admin console</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Pick an area below or use the menu on the left.
        </p>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {ADMIN_TABS.map((tab) => (
          <Link
            key={tab.key}
            to={tab.to}
            className="rounded-lg border bg-background p-4 hover:border-primary transition-colors"
          >
            <div className="font-medium">{tab.label}</div>
            <div className="text-xs text-muted-foreground mt-1">
              {TAB_DESCRIPTIONS[tab.key] ?? tab.to}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
